const cart = document.querySelector('[data-cart-wrapper]');

if (cart) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {

        const hidden = cart.getAttribute("aria-hidden");

        if (hidden !== "true") {
          window.dispatchEvent(new Event("scroll"));
          setTimeout(() => {
            BSS_B2B.nt.initFunction();
            document.dispatchEvent(new Event("DOMContentLoaded"));
          }, 300);
        }
      }
    }
  });

  observer.observe(cart, {
    attributes: true,
    attributeFilter: ["aria-hidden"] 
  });
}

const observerQuickview = new MutationObserver(() => {
  const modal = document.querySelector(".t4s-modal.t4s-modal--is-active");

  if (modal) {
    document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
  }
});


let counter = 0;
let selector = "[data-predictive-search][aria-hidden='false'] .t4s-mini-search__content";

const interval = setInterval(() => {
  let element = document.querySelector(selector);

  if (element) {

    setTimeout(() => {

      const results = document.querySelectorAll(
        '[data-results-search] .t4s-d-block.t4s-widget__pr-title'
      );

      const productTitles = [...results].map(a => a.innerText.trim());

      const productPromises = productTitles.map(productTitle => {
        return fetch('/search/suggest.json?q=' + encodeURIComponent(productTitle) + '&resources[type]=product')
          .then(response => response.json())
          .then(data => {
            if (data?.resources?.results?.products?.length > 0) {
              return {
                title: productTitle,
                productId: data.resources.results.products[0].id
              };
            } else {
              return {
                title: productTitle,
                productId: null,
                message: 'No product found'
              };
            }
          })
          .catch(error => ({
            title: productTitle,
            productId: null,
            error: 'Error fetching product data: ' + error
          }));
      });

      Promise.all(productPromises)
        .then(results => {
          results.forEach(result => {
            if (result.productId) {
              const productTitles = document.querySelectorAll(".t4s-widget__pr-title");

              const elePrice = Array.from(productTitles)
                .find(item => item.textContent === result.title)
                ?.parentNode.querySelector(".t4s-widget__pr-price");

              if (elePrice) {
                elePrice.setAttribute("bss-b2b-product-id", result.productId);
                elePrice.setAttribute("bss-b2b-product-price", "true");
              }
            }
          });
        })
        .catch(error => console.error('Error with Promise.all:', error))
        .finally(() => {
          window.dispatchEvent(new Event('scroll'));
        });

    }, 500);

    clearInterval(interval);

  } else {
    counter += 100;
    if (counter >= 10000) {
      clearInterval(interval);
    }
  }

}, 100);